export default "__VITE_ASSET__Cs7cLY32__"